import React from "react";
import { Div, Button, Img } from "glamorous";
import data from "../../../data/index";
import Colour from "./Colour";
import Font from "./Font";

import styles from "../../../styles";

export default ({
  options,
  selected,
  setCustom,
  setColour,
  setFontSize,
  setFontFamily,
  fontSize,
  fontFamily,
  activeColour,
  done,
  reset
}) => (
  <Div>
    <Div css={styles.text.ctaWrapper}>
      {options.map((option, index) => (
        <Button
          key={`option_${index}`}
          onClick={() => setCustom(option.role)}
          css={selected === option.role ? styles.text.selectedCta : styles.text.selectCta}
        >
          <Img src={selected === option.role ? option.iconWhite : option.icon} />
        </Button>
      ))}
      <Button
        css={{ ...styles.ctas.initial, ...styles.text.mobileDone }}
        onClick={() => { done() }}
      >
        {data.copy("doneMobileBtn")}
      </Button>
    </Div>
    {selected === "Colour" ? (
      <Colour activeColour={activeColour} setColour={setColour} />
    ) : (
      <Font
        fontSize={fontSize}
        fontFamily={fontFamily}
        setFontFamily={setFontFamily}
        setFontSize={setFontSize}
      />
    )}
    <Button
      onClick={() => done()}
      css={{ ...styles.ctas.initial }}
    >
      {data.copy("doneBtn")}
    </Button>
    <Button
      onClick={() => reset()}
      css={{ ...styles.ctas.outline }}
      marginTop="19px"
    >
      {data.copy("textResetBtn")}
    </Button>
  </Div>
);



// WEBPACK FOOTER //
// ./src/components/areas/EditorText/Customise.js